import { defaultTheme } from '@expo/ui/src/core/theme';
import { useChosenCharity } from '../../../../traits/context/chosenCharity';
import { MainButton, SecondaryButton } from '@expo/ui/src/buttons';
import { Input, RadioButton } from '@expo/ui/src/inputs';
import { Margin } from '@expo/ui/src/layout';
import { H3, P, ErrorText } from '@expo/ui/src/typography';
export enum WateraidSaleTechnique {
  D2D = 'D2D',
  F2F = 'F2F',
}

export type WateraidMetadata = {
  charityFlow: string;
  saleTechnique: WateraidSaleTechnique;
};

type Props = {
  onSubmit: () => void;
  setSsid: (ssid: string) => void;
  ssidError: string | null;
  ssid: string;
  metadata: WateraidMetadata;
  setMetadata: (metadata: WateraidMetadata) => void;
  setManualEntry: (manual: boolean) => void;
};

export const WateraidRetrieveSparData = ({
  onSubmit,
  setSsid,
  ssid,
  ssidError,
  metadata,
  setMetadata,
  setManualEntry,
}: Props) => {
  const { chosenCharity } = useChosenCharity();

  return (
    <>
      <Margin $top="7xl" />
      <H3>Uppge personnummer</H3>
      <P color={defaultTheme.colors.darkerGrey}>Dina uppgifter hämtas automatiskt i nästa steg</P>
      <Margin $top="xl" />
      <Input
        charityStyles={chosenCharity}
        value={ssid}
        onChangeText={newSsid => setSsid(newSsid)}
        label="Personnummer"
        placeholder="YYYYMMDDXXXX"
        maxLength={13}
      />
      <Margin $top="l" />
      {ssidError && <ErrorText>{ssidError}</ErrorText>}
      <MainButton onClick={onSubmit} charityStyles={chosenCharity}>
        Gå vidare
      </MainButton>
      <Margin $top="m" />
      <SecondaryButton onClick={() => setManualEntry(true)} type="button">
        Ange manuellt
      </SecondaryButton>

      <Margin $top="xl" />
      <P>Typ av värvning</P>
      <Margin $top="s" />
      <RadioButton
        label="D2D"
        value={WateraidSaleTechnique.D2D}
        name="sale-technique"
        onChangeValue={saleTechnique =>
          setMetadata({ ...metadata, saleTechnique: saleTechnique as WateraidSaleTechnique })
        }
        checked={metadata.saleTechnique === WateraidSaleTechnique.D2D}
      />
      <Margin $top="s" />
      <RadioButton
        label="F2F"
        value={WateraidSaleTechnique.F2F}
        name="sale-technique"
        onChangeValue={saleTechnique =>
          setMetadata({ ...metadata, saleTechnique: saleTechnique as WateraidSaleTechnique })
        }
        checked={metadata.saleTechnique === WateraidSaleTechnique.F2F}
      />
    </>
  );
};
